import React from "react";
import { useParams } from "react-router-dom";
import ExpenseForm from "../../components/expenseForm.mjs";
import ClaimQuestionsBanner from "../../clarifications/components/ClaimQuestionsBanner.mjs";

// ExpenseForm renders the page frame (PageShell) itself: its band title
// depends on the viewer and the claim, which only the form knows. On an
// existing claim, the questions an admin has put to its claimant show at the
// top - where the claimant's email lands them.
const ExpenseFormPage = () => {
  const { claimId } = useParams();
  return (
    <ExpenseForm
      questionsBanner={claimId ? <ClaimQuestionsBanner claimType="ExpenseClaim" claimId={claimId} /> : null}
    />
  );
};

export default ExpenseFormPage;
